module.exports = __webpack_public_path__ + "img/CITI.0569fb93.png";